import script from "./risk-port-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./risk-port-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

import "./risk-port-ranking-chart.vue?vue&type=style&index=0&id=71d325da&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d325da"]])

export default __exports__